import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Feature {
  id: number;
  icon: string;
  title: string;
  description: string;
  highlight: string;
}

const FeatureSection = () => {
  const features: Feature[] = [
    {
      id: 1,
      icon: "SparklesIcon",
      title: "AI-Powered Planning",
      description: "Advanced algorithms analyze your space dimensions, climate, and goals to create personalized optimization plans.",
      highlight: "Smart Recommendations"
    },
    {
      id: 2,
      icon: "RulerIcon",
      title: "Space Measurement Tools",
      description: "Interactive tools help you accurately measure and map your outdoor space for precise planning.",
      highlight: "Precision Mapping"
    },
    {
      id: 3,
      icon: "CurrencyDollarIcon",
      title: "Income Generation",
      description: "Calculate potential earnings from herb sales, vegetable production, and space rental opportunities.",
      highlight: "Revenue Tracking"
    },
    {
      id: 4,
      icon: "CalendarDaysIcon",
      title: "Production Scheduling",
      description: "Seasonal planting calendars and harvest schedules maximize your space's productive potential year-round.",
      highlight: "Seasonal Planning"
    }
  ];

  return (
    <section id="features" className="py-16 lg:py-24 bg-surface">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4 mb-16">
          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground">
            Everything You Need to
            <span className="text-primary block">Optimize Your Space</span>
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Our comprehensive platform provides all the tools and insights needed to transform any small outdoor space into a productive, income-generating area.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-card border border-border rounded-xl p-6 hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <div className="space-y-4">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={feature.icon as any} size={24} className="text-primary" />
                </div>
                
                <div className="space-y-2">
                  <div className="text-xs font-medium text-accent uppercase tracking-wide">
                    {feature.highlight}
                  </div>
                  <h3 className="text-xl font-heading font-semibold text-foreground">
                    {feature.title}
                  </h3>
                  <p className="text-muted-foreground leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;